module.exports = "/_next/static/images/3153f8a811f89531069b32cc2870348d-mother-and-daugther@0.75x.jpg";